<template>
  <el-container class="PersonnelVehicleInformation">
    <!-- 人口信息 -->
    <el-card class="tree-card" :body-style="treeCard">
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="tree-box">
        <el-tree
          :data="dataSource"
          node-key="id"
          highlight-current
          :props="{ label: 'name' }"
          :default-expanded-keys="[rootNodeKey]"
          @current-change="currentChange"
          :expand-on-click-node="true"
          :filter-node-method="filterNode"
        ></el-tree>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <h-unfold @refreshTableEmit="refreshTable">
          <template #type>
            <el-input
              clearable
              v-model="tableParams.name"
              placeholder="姓名"
              :style="{ width: '300px' }"
            ></el-input>
          </template>
          <el-form-item label="姓名" prop="name">
            <el-input
              clearable
              v-model="tableParams.name"
              placeholder="姓名"
              :style="{ width: '150px' }"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-select
              clearable
              v-model="tableParams.sex"
              placeholder="性别"
              :style="{ width: '150px' }"
            >
              <el-option
                v-for="(item, index) in sexList"
                :key="index"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="民族" prop="nation">
            <el-select
              clearable
              v-model="tableParams.nation"
              placeholder="民族"
              :style="{ width: '150px' }"
            >
              <el-option
                v-for="(item, index) in nationTypeList"
                :key="index"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄" prop="ageType">
            <el-select
              clearable
              v-model="tableParams.ageType"
              placeholder="年龄"
              :style="{ width: '150px' }"
            >
              <el-option
                v-for="(item, index) in ageList"
                :key="index"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号" prop="telphone">
            <el-input
              clearable
              v-model.number="tableParams.telphone"
              type="number"
              placeholder="手机号"
              :style="{ width: '200px' }"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <h-button type="primary" @click="refreshTable">查询</h-button>
            <h-button @click="resetForm(formRef)">重置</h-button>
          </el-form-item>
        </h-unfold>
        <el-row :style="{ 'margin-top': '10px' }">
          <el-col>
            <h-button type="primary" @click="addButton">添加</h-button>
            <h-button type="danger" @click="delUser">删除</h-button>
            <!--  -->
            <!-- <h-button
              type="primary"
              @click="exporting"
            >导出当前页</h-button>
            <h-button
              type="primary"
              @click="uploade"
            >导入</h-button>
            <h-button
              type="primary"
              @click="exportingAll"
            >导出全部</h-button>
            <h-button
              type="primary"
              @click="download"
            >模板下载</h-button>
            <input
              type="file"
              v-show="false"
              ref="file"
              @change="myup"
            /> -->
            <el-dropdown>
              <h-button type="primary" :style="{ marginLeft: '10px' }"
                >导入导出
                <el-icon class="el-icon--right">
                  <arrow-down />
                </el-icon>
              </h-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="uploade">导入</el-dropdown-item>
                  <el-dropdown-item @click="exporting"
                    >导出当前页</el-dropdown-item
                  >
                  <el-dropdown-item @click="exportingAll"
                    >导出全部</el-dropdown-item
                  >
                  <el-dropdown-item @click="download"
                    >下载模板</el-dropdown-item
                  >
                  <input type="file" v-show="false" ref="file" @change="myup" />
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-form>
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="queryUserList"
          :params="tableParams"
          :autoload="false"
          @handleClick="handleClick"
          @select="hzTableSelect"
        >
          <template #role="{ row }">
            <div class="table-role" @click="clickTable(row)">
              <span>{{ row.name }}</span>
            </div>
          </template>
          <template #houseAddress="{ row }">
            <div class="table-role" @click="clickTable(row)">
              <span :style="{ 'white-space': 'pre-wrap' }">{{
                row.houseAddress
              }}</span>
            </div>
          </template>
          <!-- <template #operate="{ row }">
            <div class="table-role">
              <el-dropdown>
                <el-button
                  type="primary"
                  :style="{ width: '60px', 'text-align': 'center' }"
                >
                  操作<el-icon class="el-icon--right">
                    <ArrowDown />
                  </el-icon>
                </el-button>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item @click="handleClick('edit', row)">编辑</el-dropdown-item>
                    <el-dropdown-item
                      @click="handleClick('del', row)"
                      :style="{'background':'red',color:'#fff'}"
                    >删除</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </template> -->
        </h-table>
      </div>
    </el-card>
    <el-dialog
      v-model="formVisible"
      :title="
        '人口' +
        (formStatus === 1 ? '新增' : formStatus === 2 ? '编辑' : '详情')
      "
      width="50%"
      height="40%"
    >
      <personnel-detail
        v-if="formVisible"
        v-model="formVisible"
        :form="userFormData"
        :status="formStatus"
        @submit="userSubmit"
      ></personnel-detail>
    </el-dialog>
    <el-dialog v-model="flag1" :style="{ width: '800px', height: '30%' }">
      <PersonneComponent
        v-if="flag1"
        :userlist="userlist"
        :idList="idList"
      ></PersonneComponent>
    </el-dialog>
  </el-container>
</template>
<script>
import fileDownload from "js-file-download";
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  ref,
  getCurrentInstance,
} from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { getDict } from "@/api/constant";
import axios from "axios";
import {
  queryUserList,
  deleteQuery,
  getUserList,
} from "@/api/realPopulation/realPopulation";
import { ArrowDown } from "@element-plus/icons-vue";
import {
  getMenutree,
  uploading,
  downloading,
  deriveing,
} from "@/api/system/region.js";
import PersonneComponent from "@/components/formDetail/PersonneComponent.vue";
import _ from "lodash";
export default defineComponent({
  name: "PersonnelVehicleInformation",
  components: { ArrowDown, PersonneComponent },
  props: {},
  setup(props) {
    const { ctx } = getCurrentInstance();
    const state = reactive({
      idList: [
        // 详情
        {
          name: "基本信息",
          id: 1,
          ids: "jbxx",
          list: [
            {
              lable: "姓名",
              value: "xm",
            },
            {
              lable: "身份证号码",
              value: "sfzhm",
            },
            {
              lable: "其他证件种类",
              value: "qtzjzl",
            },
            {
              lable: "其他证件号码",
              value: "qtzjhm",
            },
            {
              lable: "姓名拼音",
              value: "xmpy",
            },
            {
              lable: "外文姓",
              value: "wwx",
            },
            {
              lable: "外文名",
              value: "wwm",
            },
            {
              lable: "曾用名",
              value: "zym",
            },
            {
              lable: "绰号",
              value: "ch",
            },
            {
              lable: "化名",
              value: "hm",
            },
            {
              lable: "性别",
              value: "xbDict",
            },
            {
              lable: "民族",
              value: "mz",
            },
          ],
        },
        {
          name: "出生信息",
          id: 2,
          ids: "csxx",
          list: [
            {
              lable: "出生日期",
              value: "csrq",
            },
            {
              lable: "年龄",
              value: "nl",
            },
            {
              lable: "出生时间",
              value: "cssf",
            },
            {
              lable: "出生地国家",
              value: "csdgj",
            },
            {
              lable: "出生地",
              value: "csdDict", // csd
            },
            {
              lable: "出生地地址",
              value: "csddz",
            },
            {
              lable: "出生地详址",
              value: "csdxz",
            },
            {
              lable: "出生证签发日期",
              value: "cszqfrj",
            },
            {
              lable: "出生证明编号",
              value: "cszmbh",
            },
          ],
        },
        {
          name: "籍贯",
          id: 3,
          ids: "jg",
          list: [
            {
              lable: "籍贯",
              value: "jg",
            },
            {
              lable: "籍贯详址",
              value: "jgxz",
            },
            {
              lable: "国籍",
              value: "gjDict",
            },
            {
              lable: "宗教信仰",
              value: "zjxy",
            },
            {
              lable: "文化程度",
              value: "whcdDict", // whcd
            },
            {
              lable: "婚姻状况",
              value: "hyzk",
            },
          ],
        },
        {
          name: "户口信息",
          id: 4,
          ids: "hkxx",
          list: [
            {
              lable: "户口所在地类型",
              value: "szdlx",
            },
            {
              lable: "户口所在地编码",
              value: "hkszddzid",
            },
            {
              lable: "手工户号",
              value: "sghh",
            },
            {
              lable: "户口所在地户号",
              value: "hkszdhh",
            },
            {
              lable: "户口所在地行政区划",
              value: "hkszdxzqh",
            },
            {
              lable: "户口所在地派出所",
              value: "hkszdpcs",
            },
            {
              lable: "户口所在地警务区",
              value: "hkszdjwqh",
            },
            {
              lable: "户口所在地乡镇街道",
              value: "hkszdxzjd",
            },
            {
              lable: "户口所在地居委会",
              value: "hkszdjwh",
            },
            {
              lable: "户口所在地街路巷",
              value: "hkszddz",
            },
            {
              lable: "户口所在地详址",
              value: "whcd",
            },
          ],
        },
        {
          name: "实际居住地址",
          id: 5,
          ids: "sjjzdz",
          list: [
            {
              lable: "实际居住地门楼牌ID",
              value: "dzid",
            },
            {
              lable: "实际居住地房屋ID",
              value: "sjjzdhh",
            },
            {
              lable: "实际居住地行政区划",
              value: "sjjzdxzqh",
            },
            {
              lable: "实际居住地派出所",
              value: "pcsbm",
            },
            {
              lable: "实际居住地警务区",
              value: "sjjzdjwqh",
            },
            {
              lable: "实际居住地居委会",
              value: "sjjzdjwh",
            },
            {
              lable: "实际居住地址",
              value: "sjjzdz",
            },
            {
              lable: "实际居住详址",
              value: "sjjzxz",
            },
            {
              lable: "户口所在地门(楼)牌号",
              value: "hkszdmlph",
            },
          ],
        },
        {
          name: "人户一致标识",
          id: 6,
          ids: "rhyzbs",
          list: [
            {
              lable: "人户是否一致",
              value: "flyy",
            },
            {
              lable: "标注人户是否一致姓名",
              value: "rzhbzjbbtbr",
            },
            {
              lable: "标注人户是否一致警号",
              value: "rzhbzjbbtbrjh",
            },
          ],
        },
        {
          name: "其他信息",
          id: 7,
          ids: "qtxx",
          list: [
            {
              lable: "兵役状况",
              value: "byzk",
            },
            {
              lable: "身高",
              value: "sg",
            },
            {
              lable: "血型代码",
              value: "xxdm",
            },
            {
              lable: "政治面貌",
              value: "zzmm",
            },
            {
              lable: "身份",
              value: "sf",
            },
            {
              lable: "职业类别",
              value: "zylb",
            },
            {
              lable: "职业",
              value: "zy",
            },
            {
              lable: "职务",
              value: "zw",
            },
            {
              lable: "联系方式",
              value: "ljfs",
            },
            {
              lable: "电子邮件地址",
              value: "dzyjdz",
            },
            {
              lable: "移动电话",
              value: "yddh",
            },
            {
              lable: "寻呼机",
              value: "bphm",
            },
            {
              lable: "服务处所",
              value: "fwcs",
            },
          ],
        },
      ],
      userlist: [],
      flag1: false,
      filterText: "",
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      flag: false,
      dataSource: [],
      userFormData: {},
      tableParams: {
        name: "",
        sex: "",
        cardNumber: "",
        nation: "",
        telphone: "",
        age: "",
      },
      ageList: [
        // { label: '不限', value: '0' },
        // { label: '0~16', value: '1' },
        // { label: '17~40', value: '2' },
        // { label: '41~60', value: '3' },
        // { label: '61~80', value: '4' },
        // { label: '81以上', value: '5' }
      ],
      tableData: [],
      sexList: [],
      nationTypeList: [],
      // ageList: [],
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      nameVisible: false,
      columns: [
        { type: "selection" },
        {
          label: "姓名",
          hidden: true,
          slot: "role",
          width: "80px",
          // prop: "name"
        },
        {
          label: "性别",
          prop: "sexDict", // sex
          width: "60px",
        },
        {
          label: "证件号码",
          prop: "cardNumber",
        },
        {
          label: "民族",
          prop: "nationDict", // nation
        },
        {
          label: "居住地址",
          slot: "houseAddress",
          width: "250px",
        },
        {
          label: "电话",
          prop: "telphone",
        },
        {
          label: "更新时间",
          prop: "updateTime",
        },

        {
          type: "operate",
          label: "操作",
          width: "140px",
          operates: [
            { name: "编辑", emitKey: "edit" },
            { name: "删除", emitKey: "del", type: "danger" },
          ],
        },
      ],
      // queryUserList: [
      // ]
    });
    const file = ref();
    const refData = toRefs(state);
    const tableRef = ref(null);
    const formRef = ref(null);
    const error = ref();
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;
      // state.tableParams.deptId = item.deptId;
      state.tableParams.regionId = item.id;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    };
    // 获取结构树
    const queryOrganTreAsync = async () => {
      const result = await getMenutree();
      const treeData = [result.data];
      state.dataSource = treeData;
      if (treeData[0]) {
        currentChange(treeData[0]);
        nextTick(() => {
          state.rootNodeKey = "1";
        });
        state.rootNodeKey = treeData[0].children[0].id;
      }
    };
    // 导入
    const uploade = () => {
      file.value.click();
    };
    const myup = async (e) => {
      var file = e.target.files[0];
      // console.log(files, 123);
      const param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      param.append("chunk", "0"); // 添加form表单中其他数据
      var filename = file.name;
      var excelname = filename.substring(filename.lastIndexOf("."));
      console.log(excelname);
      if (excelname != ".xls" && excelname != ".xlsx") {
        alert("请先下载模板后再上传!");
      } else {
        const result = await uploading(param);
        if (result.code == 0) {
          ElMessage({
            type: "success",
            message: "上传成功",
          });
          refreshTable();
        }
        console.log("result", result);
      }
    };
    const changeflag = () => {
      state.flag = false;
    };
    // 下载模板
    const download = async () => {
      window.open(window.xlsxUrl + "实有人口信息导入模板.xlsx");
    };

    // 导出
    const exporting = async () => {
      const res = await deriveing(tableRef.value.form);
      console.log(res);
      const fileName = `${+new Date()}.xls`;
      const blob = new Blob([res], {
        type: "c",
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }
    };

    // 导出全部
    const exportingAll = async () => {
      const params = {
        allowpage: true,
      };
      const res = await deriveing(params);
      console.log(res);
      const fileName = `${+new Date()}.xls`;
      const blob = new Blob([res], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }
    };
    queryOrganTreAsync();
    // 点击查询按钮
    const refreshTable = () => {
      // this.$refs.table.refresh()
      console.log(state.tableParams);
      tableRef.value && tableRef.value.refresh();
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      if (emitKey === "edit") {
        // 编辑
        state.formStatus = 2; // 把表单设置为编辑状态
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
        nextTick(() => {});
      } else if (emitKey === "info") {
        // 详情
        state.formStatus = 3; // 把表单设置为查看状态
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
      } else if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该人口信息吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            deleteUserAsync([row.prisonId]);
          },
          () => {}
        );
      }
    };
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    // 点击添加按钮
    const addButton = () => {
      state.formStatus = 1;
      state.formVisible = true;
    };
    const deleteUserAsync = async (ids) => {
      // const parms = {
      //   prisonIds: ids
      // };
      const res = await deleteQuery(ids);
      if (res.code === 0) {
        refreshTable();
        ElMessage({
          type: "success",
          message: "删除成功",
        });
      }
    };
    // 批量删除用户
    const delUser = () => {
      if (state.tableSelection.length > 0) {
        ElMessageBox.confirm("您确认要删除选择的用户吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            const ids = state.tableSelection.map((item) => item.prisonId);
            deleteUserAsync(ids);
            state.tableSelection = [];
          },
          () => {}
        );
      } else {
        ElMessage({
          type: "warning",
          message: "请选择要删除的用户",
        });
      }
    };
    // 获取数据字典
    const queryMenuType = async () => {
      // nationType 民族
      const res = await getDict("sex");
      const nationType = await getDict("nationType");
      const age = await getDict("ageDurationType");

      state.sexList = res.dict;
      state.nationTypeList = nationType.dict;
      state.ageList = age.dict;
    };
    queryMenuType();
    const clickTable = async (item) => {
      if (window.isDetail) {
        state.formStatus = 3;
        state.formVisible = true;
        state.userFormData = _.cloneDeep(item);
      } else {
        state.flag1 = !state.flag1;
      }
      getList(item.rid);
    };
    const getList = async (rid) => {
      const params = {
        rid: rid,
      };
      const res = await getUserList(params);
      state.userlist = res.data;
      console.log(state.userlist, 66666);
    };

    return {
      ...refData,
      filterNode,
      currentChange,
      addButton,
      refreshTable,
      resetForm,
      delUser,
      hzTableSelect,
      handleClick,
      queryUserList,
      userSubmit,
      tableRef,
      formRef,
      clickTable,
      ...toRefs(state),
      uploade,
      file,
      myup,
      error,
      changeflag,
      download,
      exporting,
      exportingAll,
      ArrowDown,
    };
  },
});
</script>
<style lang="scss" scoped>
.PersonnelVehicleInformation {
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      .table-role {
        color: #294a7c;
        cursor: pointer;
        span {
          border-bottom: 1px solid;
        }
      }
    }
  }
}
</style>
